import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { DPARAModalComponent } from './d-para-component/dparamodal/dparamodal.component';
import { Validators } from 'ngx-editor';
import { Subject } from 'rxjs';
import { CardView } from 'src/app/interfaces/cardview';
import { HTTPService } from 'src/app/services/http.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { JsonConfigComponent } from './json-config/json-config.component';


interface Entity {
  value: string;
  viewValue: string;
}

@Component({
    selector: 'app-importacao-dados',
    templateUrl: './importacao-dados.component.html',
    styleUrls: ['./importacao-dados.component.scss'],
    standalone: false
})
export class ImportacaoDadosComponent implements OnInit {


  @ViewChild('datagridCfg') datagridCfg;
  @ViewChild('datagridImp') datagridImp;
  @ViewChild('datagridImpLog') datagridImpLog;

  activecompanies:Object;
  selectedEntity: Entity;
  dparaConfig: any = {};
  
  errorMessage = '';
  firstFormGroup: UntypedFormGroup;
  eventsSubject: Subject<string> = new Subject<string>();  
  conditionCfg:string = '0=1';
  conditionImp:string = '0=1';
  conditionImpLog:string = '0=1';
  isTestMode:any;
  conditionSearch:string = '0=0';
  codecompany:Number;
  codecontract:Number;
  idUser:any;
  instanceName:any;
  idInstance:Number;
  parentRow:CardView;
  rows:any;
  rowsImp:any;
  nuCfg:any;
  tableName: string = "";
  configId: string;
  tabIds: string[] = ['Mktpuserimportcfg', 'ImportacaoLinhasImportadas'];



  constructor(private modal: NzModalService, private _formBuilder:UntypedFormBuilder, private http:HTTPService,public uas:UserAuthenticationServices, private snackServices:SnackbarService,private cdRef: ChangeDetectorRef, private ls: LanguageServices) {

   }

   

  ngOnInit(): void {

    this.tableName = this.ls.instant('importacao.selectConfig');

    this.firstFormGroup = this._formBuilder.group({
      IDINSTANCE: ["", Validators.required],
    });

      
  
    if  ( this.uas.user.companylist.length > 1 ){ 
      this.codecompany = null;
      this.codecontract = null;
    }else{
      this.codecompany = Number(this.uas.user.companylist[0].codecompany);
      this.codecontract = Number(this.uas.user.companylist[0].codecontract)              
    }

    this.idUser = this.uas.user.iduser;

    this.conditionCfg = `idUser=${this.idUser} and codecompany=${this.codecompany}`
    this.conditionImp = `idUser=${this.idUser} and codecompany=${this.codecompany}`
    this.conditionSearch = ` EXISTS (SELECT 1 FROM Mktpdiccol c where  c.idinstance  = entityPrincipal.idinstance and c.columnname = 'CODECOMPANY')`
  }

  updateDatagrid(datagrid): void {
    datagrid.apply();   
}

  openDPARAModal(): void {

    if(this.codecompany == null){
      throw Error(this.ls.instant('importacao.msg.companyNotConfigured'));
    }

    let self = this;

    self.idInstance = this.firstFormGroup.get("IDINSTANCE").value;

    if(this.idInstance){
      let obinfo = {
        "entityName":"Mktpdic",
        "sql":`SELECT INSTANCENAME FROM Mktpdic (nolock) WHERE IDINSTANCE=${self.idInstance}`
      }         
      

      this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
        if( ObjectUtil.isNotEmpty(conInfo['SQL'])){

          self.instanceName  = conInfo['SQL'][0]['INSTANCENAME'];

          const dialogRef = this.modal.create({
            nzContent: DPARAModalComponent,
            nzWidth: '1480px',
            nzFooter: null,
            nzClosable: false,
            nzData: {idInstance: self.idInstance, instanceName: self.instanceName, dpara: this.dparaConfig}
          });

          dialogRef.afterClose.subscribe(result => {
              if (result) {
                
                
                this.dparaConfig = result;
              
                              
                let jsonSave: Object = {
                  entityName: "Mktpuserimportcfg",
                  NUINSTANCE: self.idInstance,
                  IDUSER: this.idUser,
                  CODECOMPANY: this.codecompany,
                  INSTANCENAME: self.instanceName,                  
                };                          
              
                jsonSave['CONFIG'] =  JSON.stringify(this.dparaConfig);
                
                this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe( d=>{
                    this.snackServices.showSuccess(this.ls.instant('importacao.msg.saved'))                    
                });
                  
              }          
          });
        }
  
        
      });

       
    }
  }

openJsonDPARAModal(): void {

    if(this.codecompany == null){
      throw Error(this.ls.instant('importacao.msg.companyNotConfigured'));
    }

    let self = this;

    self.idInstance = this.firstFormGroup.get("IDINSTANCE").value;

    if(this.idInstance){
      let obinfo = {
        "entityName":"Mktpdic",
        "sql":`SELECT INSTANCENAME FROM Mktpdic (nolock) WHERE IDINSTANCE=${self.idInstance}`
      }         
      

      this.http.post(obinfo,'JsonBrokerServices/findnative',false,true,true).subscribe(conInfo=>{
        if( ObjectUtil.isNotEmpty(conInfo['SQL'])){

          self.instanceName  = conInfo['SQL'][0]['INSTANCENAME'];

          const dialogRef = this.modal.create({
            nzContent: JsonConfigComponent,
            nzWidth: '1480px',
            nzFooter: null,
            nzClosable: false,
            nzData: {idInstance: self.idInstance, instanceName: self.instanceName, dpara: this.dparaConfig}
          });

          dialogRef.afterClose.subscribe(result => {
              if (result) {
                
                this.dparaConfig = result;
              
                              
                let jsonSave: Object = {
                  entityName: "Mktpuserimportcfg",
                  NUINSTANCE: self.idInstance,
                  IDUSER: this.idUser,
                  CODECOMPANY: this.codecompany,
                  INSTANCENAME: self.instanceName,                  
                };                          
              
                jsonSave['CONFIG'] =  JSON.stringify(this.dparaConfig);
                
                this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe( d=>{
                    this.snackServices.showSuccess(this.ls.instant('importacao.msg.saved'))                    
                });
                  
              }          
          });
        }
  
        
      });

       
    }
  }


  onCompanyChange(codecompany): void {
    this.codecompany = codecompany;
    this.getActiveCompanies();
  }

  getActiveCompanies(){
    let ob = {
      "entityName":"Mktpactivecompanies",
      "sql":`SELECT A.*
            FROM MKTPACTIVECOMPANIES A INNER JOIN MKTPCOMPANIES B ON A.CODECOMPANY=B.CODECOMPANY
            WHERE A.CODECOMPANY=${this.codecompany}            
            AND A.STATUS=1
            AND A.ENVIRONMENT=1`
    }

    let self = this;
     
    this.http.post(ob,'JsonBrokerServices/findnative',false,true,true).subscribe(con=>{
         
        if( ObjectUtil.isNotEmpty(con['SQL'])){
          this.activecompanies  = con['SQL'][0];
          this.conditionCfg = `idUser=${this.idUser} and codecompany=${this.codecompany}`;
          this.conditionImp = `idUser=${this.idUser} and codecompany=${this.codecompany}`;
          this.conditionImpLog = "1=0";

          this.updateDatagrid(this.datagridCfg);
          this.updateDatagrid(this.datagridImp);
          this.updateDatagrid(this.datagridImpLog);
        }else{
          throw Error(this.ls.instant('importacao.msg.companyNotConfigured'));
        }
      });
  }

  getConditionFunction = () => this.conditionCfg;
  getConditionImpFunction = () => this.conditionImp;
  getConditionLogFunction = () => this.conditionImpLog;
  
  downloadTemplate(): void {    

    if ( ObjectUtil.isNotEmpty(this.rows)){

      
      if(this.rows && this.rows.length == 1){

        let jsonCFG: Object = {
          idCfg: this.rows[0]['NUCFG']
        }; 
        
        var idCfg = this.rows[0]['NUCFG'];
        var instanceName = this.rows[0]['INSTANCENAME'];
            
        this.http.downloadFile(`impExp/${idCfg}/downloadModelCSV`,true, true).subscribe(data=>{
          let blob = new Blob([data.toString()], { type: 'text/csv' });
          
          let url = window.URL.createObjectURL(blob);

          let link = document.createElement('a');
          link.href = url;
          link.download = idCfg+"_"+instanceName+'.csv';
          link.click();
    
        });

      
      }else{
        this.snackServices.showSuccess(this.ls.instant('importacao.msg.oneTemplate'))      
      }              
     
    
    }
  }

   
  downloadTable(): void {    

    if ( ObjectUtil.isNotEmpty(this.rows)){

      
      if(this.rows && this.rows.length == 1){

        let jsonCFG: Object = {
          idCfg: this.rows[0]['NUCFG']
        }; 
        
        var idCfg = this.rows[0]['NUCFG'];
        var instanceName = this.rows[0]['INSTANCENAME'];
            
        this.http.downloadFile(`impExp/${idCfg}/downloadTableDataCSV`,true, true).subscribe(data=>{
          let blob = new Blob([data.toString()], { type: 'text/csv' });
          
          let url = window.URL.createObjectURL(blob);

          let link = document.createElement('a');
          link.href = url;
          link.download = 'data_'+instanceName+'.csv';
          link.click();
    
        });

      
      }else{
        this.snackServices.showSuccess(this.ls.instant('importacao.msg.oneTemplate'))      
      }              
     
    
    }
  }
  
  
  selecteRow = (rowsSelect) => {
    this.rows = rowsSelect;  
    
    
    if(this.rows != null && this.rows.length  == 1) {

      this.tableName = this.rows[0]['INSTANCENAME'];
      this.configId = this.rows[0]['NUCFG'];
      
      this.conditionImp = `idUser=${this.idUser} and codecompany=${this.codecompany} and nuCfg=${this.rows[0]['NUCFG']}`           
    }else{
      this.conditionImp = `idUser=${this.idUser} and codecompany=${this.codecompany}`
    }
        
    this.updateDatagrid(this.datagridImp); 
  }

  selecteRowImp = (rowsSelect) => {
    this.rowsImp = rowsSelect;  
    
    if(this.rowsImp != null && this.rowsImp.length  == 1) {
      this.conditionImpLog = `idtask=${this.rowsImp[0]['IDTASK']}`      
    }else{
      this.conditionImpLog = `1=0`
    }
         
    this.updateDatagrid(this.datagridImpLog); 
  }



  uploadFile(event): void {
    const file = event.target.files && event.target.files[0];

    if (!file) {
      return;
    }

    if (!file.name.endsWith('.csv')) {
      throw Error(this.ls.instant('importacao.msg.csvOnly'));
    }

    if(this.codecompany == null){
      throw Error(this.ls.instant('importacao.msg.companyNotConfigured'));
    }

    if(this.rows != null && this.rows.length == 1){
           
      var idCfg = this.rows[0]['NUCFG'];        

      const formData = new FormData();
      formData.append('file', file);
      formData.append('IDUSER', this.idUser);  
      formData.append('NUCFG', idCfg);  
      formData.append('CODECOMPANY', this.codecompany.toString()); 
      formData.append('TESTMODE', this.isTestMode); 
      
      

      this.http.postFile(formData, "impExp/uploadfile", false, true, false).subscribe(
        event => {
          if (event.status === 'progress') {
            console.log('Upload progress:', event.message);  
                               
          } else {

            if (event.resultado) {            
              this.snackServices.showSuccess(this.ls.instant('importacao.msg.imported'));

              this.updateDatagrid(this.datagridCfg);
              this.updateDatagrid(this.datagridImp);
              this.updateDatagrid(this.datagridImpLog);
            }   

            console.log('Upload response:', event);                        
          }
        },
        error => {
          console.error('Upload error:', error);          
          this.snackServices.showError(error.message) ;
        }
      );
        

    }else{
      throw Error(this.ls.instant('importacao.msg.selectRow'));                    
    }
 
  }


  

  onTabChanged(index: number){
    if (index >= 0 && index < this.tabIds.length) {
      this.eventsSubject.next(this.tabIds[index]);
    }
  }
}


